module.exports = __webpack_public_path__ + "static/media/eirich-mixer-testing-s.b3cc37b5.webp";